<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5">
            </b-media>
        </base-header>
        
        <b-container class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-6 mb-3">
                    <div class="col-md-12">
                        <p>Consulter le <a style="color: #2dcecc;" target="_blank" href="https://www.medicasure.com/particuliers/consentement-eclaire">Consentement éclairé</a> et apporté votre signateure ci-dessous</p>
                       
                    </div>
                    <div class="col-md-12 border bg-white">
                        <img :src="dataUrl" class="img-fluid" v-if="dataUrl!= null && !disabled">
                        <vueSignature v-else ref="signature" :sigOption="option" :w="'450px'" :h="'300px'"></vueSignature> 
                    </div>
                    <div class="col-md-12 text-center mt-3">
                        <button @click="save" class="btn btn-primary">Enregistrer</button>
                        <button @click="clear" class="btn btn-secondary">Modifier</button>
                        <button @click="undo" class="btn btn-danger">Arrière</button>
                    </div>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
    import AppConfig from "../../constants/AppConfig";
    import vueSignature from "vue-signature";
    import Vue from 'vue';
    import _ from "lodash";
    import axios from 'axios';

    export default {
        name: "Signature",
        components:{
            vueSignature
        },
        data() {
            return {
                option:{
				    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"rgb(255,255,255)"
                },
                disabled: JSON.parse(localStorage.getItem('user'))['signature'] == null ? true : false,
                dataUrl: JSON.parse(localStorage.getItem('user'))['signature'],
            }
        },

        methods: {
            
            /**
             * signature
             */
            
          
            save(){
                var _this = this;
                const signature = _this.$refs.signature.save();
                const formData = new FormData();
                formData.append('signature', signature)
                formData.append('id', JSON.parse(localStorage.getItem('user'))['id'])

                axios.post(`${AppConfig.apiUrl}/signature/user`, formData, {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'Authorization': "Bearer " + localStorage.getItem('ms-token')
                    }
                }).then(res => {
                    this.$bvModal.hide('consentement');
                    let user = JSON.parse(localStorage.getItem('user'));
                    user = {...user, signature: res.data.signature};
                    localStorage.setItem("user", JSON.stringify(user));
                    this.disabled = false;
                    this.dataUrl = res.data.signature;
                    Vue.swal("Signature mise à jours avec succès", '', 'success');
                }).catch(error => {
                    console.log('error ', error);
                })

            },
            clear(){
                var _this = this;
                this.disabled = true;
                _this.$refs.signature.clear();
            },
            undo(){
                var _this = this;
                _this.$refs.signature.undo();
            }
        },

        mounted() {
           
        },

    }
</script>
